

export default {
    props: [
        'error',
    ],

  head: function () {
    return {
      // суффикс «- Central Trans» добавит titleTemplate из layouts/default.vue
      title: "Страница не найдена",
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, follow' },
        { hid: 'metadescription', name: 'description', content: '' },
      ],
    }
  },

  computed: {
    message: function () {
      let message = this.error?.message || "Страница не найдена";
      if (message === "Page not found" || message === 'Category error not found') {
        message = "Страница не найдена"
      }

      return message
    }
  }
};
